// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".a83172f859a8c8fec82ec5afcc763181f0e0a8a2.chunk.js";
};